// import RulePack from './RulePack';

export default {
  priority: 1,
  path: "ApiSettings",
  permissions: ["RequestsMenu/RequestPattern/PatternDefinitionMenu"],
  // component: RulePack,
  component: load(() =>
    import(/* webpackChunkName: "Request-pattern-RulePack" */ "./ApiSettings")
  ),
  name: app.translate("تنظیمات پیامک"),
  icon: "content-paste",
  drawer: true,
};
